import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useRejectLimitData = () => {
  const [data, setData] = useState({
    number_reject_max: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!verifyTokenExpire()) return;

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${appConfig.apiDomaine}/configurations/reject-unit-transfer-limitation`
      );

      setData({
        number_reject_max: response.data.number_reject_max || 0,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error, refetch: fetchData };
};
